<template>
  <div>
    <b-card>
      <div class="text-right mb-3">
      </div>
      <grid-filters grid-data="isolatedGrid" :fields="gridFilters"></grid-filters>
      <Grid ref="isolatedGrid" name="isolatedGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns"
        :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
    </b-card>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'isolatedPullRequestsdGrid',
  components: {
    Grid
  },
  data() {
    return {
      itemToDelete: null,
      filters: {
        dsr: null,
        dsr_id: null
      },
      gridFilters: [{
        field: 'dsr_id',
        placeholder: 'DSR'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      preload: [],
      url: 'isolated/pull_requests',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'dsr_id',
        title: 'Dsr_ID',
        width: '100px'
      },
      {
        field: 'dsr_name',
        title: 'Nome',
        width: '220px'
      },
      {
        field: 'dsr_username',
        title: 'Username',
        width: '160px'
      },
      {
        field: 'so_name',
        title: 'SO',
        width: '120px'
      },
      {
        field: 'cha_name',
        title: 'CHA',
        width: '120px'
      },
      {
        field: 'ufs_points',
        title: 'UFS',
        width: '120px'
      },
      {
        field: 'ola_points',
        title: 'OLA',
        width: '120px'
      },
      {
        field: 'total',
        title: 'Total',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        width: '180px'
      }]
    }
  },
  methods: {
    getBtnTemplate: function (item) {
      var route = router.resolve({
        name: 'pull_requests.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('pull_requests.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i></a>'
      }
      return ''
    }
  }
}
</script>
